import React, { useState } from "react"
import { Button, Card, CardBody, CardHeader, Col, Collapse, Row } from "reactstrap"
import { useExecutionInfo } from "../hooks/useExecutionInfo"
import WordCloudSlide from './WordCloudSlide'

const WordCloudSection: React.FC<{ id: string }> = ({ id }) => {
  const { data: executionData } = useExecutionInfo(id)

  const [wcCollapsed, setWcCollapsed] = useState(true)
  const [activeSlideIdx, setActiveSlideIdx] = useState(0)

  return (
    <Row>
      <Col className="order-xl-1">
        <Card className="bg-secondary shadow">
          <CardHeader className="bg-white border-0">
            <h4 style={{ display: 'inline' }}>
              Word Clouds
            </h4>
            <span className="float-right">
              <Button size="sm" color="primary" onClick={() => {
                setWcCollapsed(!wcCollapsed)
              }}>
                {wcCollapsed ? 'Expand' : 'Collapse'}
              </Button>
            </span>
          </CardHeader>
          <Collapse isOpen={!wcCollapsed}>
            <CardBody className="overflow-auto">
              <div className="mb-3">
                <Button color="info" size="sm" onClick={() => {
                  if (activeSlideIdx === 0) return
                  setActiveSlideIdx(activeSlideIdx - 1)
                }}>
                  Prev
                </Button>
                <Button className="ml-2" color="info" size="sm" onClick={() => {
                  if (!executionData?.wordcloudUrls || activeSlideIdx === executionData?.wordcloudUrls?.length - 1) return
                  setActiveSlideIdx(activeSlideIdx + 1)
                }}>
                  Next
                </Button>
              </div>
              <div>
                {
                  executionData?.wordcloudUrls?.map((url, i) => (
                    <WordCloudSlide
                      key={i}
                      idx={i}
                      activeSlideIdx={activeSlideIdx}
                      url={url}
                    />
                  ))
                }
              </div>
            </CardBody>
          </Collapse>
        </Card>
      </Col>
    </Row>
  )
}

export default WordCloudSection
